<template>
  <div class="rounded-lg border border-slate-600/70 bg-slate-900/35 p-3 space-y-3">
    <p class="text-sm font-medium text-slate-200">Documentos</p>
    <p v-if="!allowUpload" class="text-xs text-amber-200/90 leading-snug">
      Salve o agente para enviar arquivos.
    </p>
    <input
      :key="fileInputKey"
      type="file"
      multiple
      :disabled="!allowUpload || uploading"
      accept=".pdf,.txt,.csv,.xlsx,.xls,.doc,.docx,application/pdf,text/plain,text/csv"
      class="w-full text-sm text-slate-200 file:mr-3 file:px-3 file:py-2 file:rounded file:border-0 file:bg-slate-800 file:text-slate-100 hover:file:bg-slate-700 disabled:opacity-50"
      @change="onFileChange"
    />
    <p class="text-xs text-slate-400 leading-snug">
      PDF, TXT, CSV, Excel e Word. Até 25 MB por arquivo; envio em lote ao salvar o agente.
    </p>
    <div v-if="documents.length" class="space-y-1.5">
      <p class="text-xs font-medium text-slate-400">No servidor</p>
      <div
        v-for="doc in documents"
        :key="doc.signed_id"
        class="flex items-center justify-between gap-2 rounded border border-slate-600/50 bg-slate-900/40 px-2 py-1.5"
      >
        <div class="min-w-0 flex-1">
          <p class="text-xs text-slate-200 truncate" :title="doc.filename">{{ doc.filename }}</p>
          <p class="text-[11px] text-slate-500">{{ humanSize(doc.byte_size) }}</p>
        </div>
        <button
          type="button"
          class="shrink-0 text-[11px] px-2 py-1 rounded border border-rose-500/40 text-rose-200 hover:bg-rose-500/10 disabled:opacity-50"
          :disabled="uploading || !allowUpload"
          @click="$emit('remove-document', doc.signed_id)"
        >
          Remover
        </button>
      </div>
    </div>
    <div v-if="pendingFiles.length" class="space-y-1">
      <p class="text-xs font-medium text-slate-400">Serão enviados ao salvar</p>
      <div v-for="(f, idx) in pendingFiles" :key="`${f.name}-${idx}`" class="text-xs text-amber-200">
        {{ f.name }} <span class="text-amber-300/85">({{ humanSize(f.size) }})</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentDocuments',
  props: {
    documents: { type: Array, default: () => [] },
    pendingFiles: { type: Array, default: () => [] },
    allowUpload: { type: Boolean, default: false },
    uploading: { type: Boolean, default: false },
    fileInputKey: { type: Number, default: 0 }
  },
  emits: ['files-selected', 'remove-document'],
  methods: {
    humanSize(n) {
      const b = Number(n) || 0
      if (b < 1024) return `${b} B`
      if (b < 1024 * 1024) return `${Math.max(1, Math.round(b / 1024))} KB`
      return `${(b / (1024 * 1024)).toFixed(1)} MB`
    },
    onFileChange(e) {
      this.$emit('files-selected', e)
    }
  }
}
</script>
